import AgencySaleAddOrderScreen from 'features/Agency/screens/AgencySaleAddOrderScreen';
import DealerDetailScreen from 'features/ManageDealer/screens/DealerDetailScreen';
import InvestorDetailScreen from 'features/ManageInvestor/screens/InvestorDetailScreen';
import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import SubAgenciesListScreen from './screens/SubAgenciesListScreen';
import EditAgencyScreen from 'features/ManageDealer/screens/EditAgencyScreen';

function ManageSubAgencies(props) {
  const { role } = props;

  return (
    <KT01BaseLayout isFullScreen={true}>
      <div className="container-fluid px-0 pb-4">
        <Routes>
          <Route path="" element={<SubAgenciesListScreen role={role} />} />
          <Route
            path="/:agencyId"
            element={
              role === 'SALE' ? (
                <DealerDetailScreen />
              ) : role === 'INVESTOR' ? (
                <InvestorDetailScreen />
              ) : (
                <></>
              )
            }
          />
          <Route
            path={"/add"}
            element={<EditAgencyScreen agencyRole="SALE" />}
          />
          <Route
            path={"/:agencyId/edit"}
            element={<EditAgencyScreen agencyRole="SALE" />}
          />
          <Route
            path={"/:agencyId/add"}
            element={<EditAgencyScreen agencyRole="SALE" isAddSubAgency={true} />}
          />
          <Route path="/add-order" element={<AgencySaleAddOrderScreen removeBaseLayout={true} />} />
          <Route path="/:agencyId/add-order" element={<AgencySaleAddOrderScreen removeBaseLayout={true} />} />
          <Route path="*" element={<>Not found</>} />
        </Routes>
      </div>
    </KT01BaseLayout>
  );
}

export default ManageSubAgencies;
